// GTM Event: Free Catalog Form Submission
// Escucha envíos del formulario Shopify Forms en /pages/request-a-free-catalog
// Form ID: 948159

(function() {
  const CATALOG_FORM_ID = '948159';

  // Solo ejecutar en /pages/request-a-free-catalog
  if (!window.location.pathname.includes('/pages/request-a-free-catalog')) {
    return;
  }

  // Evita duplicados si el evento se dispara más de una vez
  let catalogEventSent = false;
  const emailUtils = window.GTMEmailUtils || {};

  function pushCatalogEvent(source, detail) {
    if (catalogEventSent) return;

    const submittedFormId = String(detail?.form_id || detail?.id || '');

    // Si viene form_id, validamos que sea el formulario de catalogo
    if (submittedFormId && submittedFormId !== CATALOG_FORM_ID) {
      return;
    }

    if (typeof window.dataLayer === 'undefined') {
      window.dataLayer = [];
    }

    const email =
      typeof emailUtils.getEventEmail === 'function'
        ? emailUtils.getEventEmail(detail)
        : '';

    window.dataLayer.push({
      event: 'catalog_form_submission',
      form_name: 'Free Catalog',
      form_id: CATALOG_FORM_ID,
      submit_status: 'success',
      form_source: 'shopify_forms',
      page_type: 'request_free_catalog',
      trigger_source: source,
      email: email
    });

    catalogEventSent = true;
    console.log('✓ Catalog form submitted (success)', { source: source, detail: detail });
  }

  // Shopify Forms puede emitir diferentes nombres de evento segun version/embed
  ['form_submitted', 'shopify:form_submitted', 'shopify:forms:submitted'].forEach(function(evtName) {
    window.addEventListener(evtName, function(event) {
      pushCatalogEvent(evtName, event?.detail || null);
    });

    document.addEventListener(evtName, function(event) {
      pushCatalogEvent(evtName + ':document', event?.detail || null);
    });
  });

  // Fallback para embeds en iframe que reportan exito via postMessage
  window.addEventListener('message', function(event) {
    if (catalogEventSent) return;

    const raw = event?.data;
    const text = typeof raw === 'string' ? raw : JSON.stringify(raw || {});
    const normalized = text.toLowerCase();

    const looksSuccessful =
      normalized.indexOf('submitted') !== -1 ||
      normalized.indexOf('success') !== -1;

    if (!looksSuccessful) return;
    if (text.indexOf(CATALOG_FORM_ID) === -1) return;

    pushCatalogEvent('postmessage_success', { form_id: CATALOG_FORM_ID, raw: raw });
  });

  // Fallback: detectar envio exitoso por respuesta de red con referencia al form 948159
  function bodyContainsCatalogId(body) {
    if (!body) return false;
    if (typeof body === 'string') return body.indexOf(CATALOG_FORM_ID) !== -1;

    try {
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        let found = false;
        body.forEach(function(value) {
          if (String(value).indexOf(CATALOG_FORM_ID) !== -1) found = true;
        });
        return found;
      }

      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        return body.toString().indexOf(CATALOG_FORM_ID) !== -1;
      }
    } catch (e) {
      return false;
    }

    return false;
  }

  function isLikelyShopifyFormSubmit(url) {
    if (!url) return false;
    const value = String(url).toLowerCase();
    return value.indexOf('shopify') !== -1 || value.indexOf('forms') !== -1;
  }

  if (typeof window.fetch === 'function') {
    const originalFetch = window.fetch;
    window.fetch = function(input, init) {
      const requestUrl = typeof input === 'string' ? input : (input && input.url) || '';
      const requestBody = (init && init.body) || '';

      return originalFetch.apply(window, arguments).then(function(response) {
        if (
          response &&
          response.ok &&
          isLikelyShopifyFormSubmit(requestUrl) &&
          bodyContainsCatalogId(requestBody)
        ) {
          pushCatalogEvent('fetch_success', {
            form_id: CATALOG_FORM_ID,
            url: requestUrl,
            email:
              typeof emailUtils.getEventEmail === 'function'
                ? emailUtils.getEventEmail(null, requestBody)
                : ''
          });
        }

        return response;
      });
    };
  }
})();
